// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__28wOT","spin":"styles_spin__451up"};